document.addEventListener("DOMContentLoaded", function () {
  fetch("https://api.country.is/")
    .then((response) => response.json())
    .then((data) => {
      const isUS = data.country === "US";
      const regionToShow = isUS ? "us" : "non-us";

      document.querySelectorAll("[data-region]").forEach((el) => {
        const defaultDisplay = window
          .getComputedStyle(el)
          .getPropertyValue("display");
        if (el.dataset.region === regionToShow) {
          el.style.display =
            defaultDisplay === "none" ? "inline-flex" : defaultDisplay;
        }
      });
    });
});
